import { Outlet, useLocation } from 'react-router-dom';
import { Box, Flex, Link } from '@gusto/workbench';
import trackSignInClicked from 'packages/signup/analytics/trackSignInClicked';
import ProgressBar from '../../../../components/progress_bar';
import { useSignupContext } from '../signupProvider';
import calculateProgressPercentage from './progressPercentageCalculation';

const BRAND_REFRESH_MOBILE_ILLUSTRATION_URL =
  'https://res.cloudinary.com/dja3z8nt6/image/upload/v1786033904/GrowingGoodness_xymrej.png';

export default function AccountantsInviteLayout({
  accountingFirmName,
  accountingFirmLogoUrl,
}: {
  accountingFirmName: string;
  accountingFirmLogoUrl: string | undefined;
}) {
  const signupContext = useSignupContext();
  const { pathname } = useLocation();

  const showingForm = pathname.includes('/sign_up_form');

  return (
    <>
      <section className="partners-signup-layout">
        <Flex width="100wh" flexDirection="column" flexDirectionMd="row">
          {!showingForm && (
            <ProgressBar
              percentage={calculateProgressPercentage(signupContext)}
              headerId="#lead-nav"
            />
          )}
          <Flex
            heightMd="100vh"
            widthLg="50%"
            widthMd="54%"
            flexDirection="column"
            alignItems="center"
            justifyContent="space-between"
            className={`get-started-box ${showingForm ? '' : 'white-background'}`}
          >
            {showingForm ? (
              <Box textAlign="center" marginTop="20px">
                <h2>Thanks!</h2>
                <p className="layout-subheading">
                  Finish creating your account and don’t pay a cent until you run your first
                  payroll.
                </p>
              </Box>
            ) : (
              <Box textAlign="center" paddingTop="20px" paddingLeft="20px" paddingRight="20px">
                {accountingFirmLogoUrl && (
                  <img
                    src={accountingFirmLogoUrl}
                    alt={`${accountingFirmName} Logo`}
                    style={{ maxHeight: '48px', maxWidth: '200px' }}
                  />
                )}
                <h1 className="h2 text-center margin-bottom-10px margin-top-30px">
                  See how easy payroll and benefits can be
                  <br />
                  with Gusto &amp; {accountingFirmName}
                </h1>
                <p className="text-default grey-text">
                  Already use Gusto?{' '}
                  <Link onClick={trackSignInClicked} href="/login">
                    Sign in
                  </Link>
                </p>
              </Box>
            )}
            {!showingForm && (
              <img
                className="plant-shop-cropped plant-shop-cropped-brand-refresh"
                alt="Gardener planting"
                src={BRAND_REFRESH_MOBILE_ILLUSTRATION_URL}
              />
            )}
          </Flex>
          <Flex
            widthLg="50%"
            widthMd="46%"
            alignItems="center"
            justifyContent="center"
            overflow="scroll"
            className={`question-box ${showingForm ? '' : 'partners-surface-page'}`}
          >
            <Outlet />
          </Flex>
        </Flex>
      </section>
    </>
  );
}
